import { Observable } from 'rxjs';

export const prefersDark$ = new Observable<boolean>((subscriber) => {
  const mql = window.matchMedia('(prefers-color-scheme: dark)');
  subscriber.next(mql.matches);

  const handler = (event: MediaQueryListEvent): void => subscriber.next(event.matches);
  mql.addEventListener('change', handler);

  return () => mql.removeEventListener('change', handler);
});
